/**
 *
 * @typedef {Object} DisplayQueueItem
 * @property {string} name
 * @property {number} count
 * @property {number} start_time
 * @property {boolean} [isOwn]
 */

export const emojiHistory = (state) => state.emoji.history;
/*
export const getChunkBound = (state, chunk) => {
	if (!chunk){
		return
	}
}
*/
/**
 *
 * @param {State} state
 * @param {number} position
 * @return {boolean|[]}
 */
function getHistoryChunk(state, position) {
  return emojiHistory(state).find(({ from, to }) => {
    return position >= from && position <= to;
  });
}

export default getHistoryChunk;

export function getEmojiUpdateInterval(state) {
  const { updateInterval } = state.emoji;
  return updateInterval;
}
